import './vendorSetup';
// Must run before the first render so the detected locale is active on mount.
import './i18n';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installChunkReloadHandler } from './utils/chunkReload';

// Recover tabs left open across a deploy instead of rendering a blank page.
installChunkReloadHandler();

// Initialize theme on load
(function () {
  const theme = localStorage.getItem('theme') || 'dark';
  const htmlElement = document.documentElement;
  const bodyElement = document.body;

  if (theme === 'dark') {
    htmlElement.classList.add('dark-mode');
    bodyElement.classList.add('dark-mode');
  } else {
    htmlElement.classList.remove('dark-mode');
    bodyElement.classList.remove('dark-mode');
  }
})();

// ResizeObserver suppression is in public/index.html (inline <script> in <head>)
// so it fires before CRA's react-error-overlay registers its handler.

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

